import styled, { css } from 'styled-components';
import { COLOR_WHITE, COLOR_RED, COLOR_DARK_ORANGE } from '../../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  background: ${COLOR_WHITE};
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
  padding: 16px 24px;
  width: 100%;
  max-width: 803px;
  border-radius: 12px;
  margin-bottom: 24px;
  &.completed {
    background: #0dbb53;
  }
  &.refused {
    background: ${COLOR_RED};
  }
  &.waiting {
    background: ${COLOR_WHITE};
  }
  &.confirmation-pending {
    background: ${COLOR_WHITE};
  }
`;

export const CardTopSC = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;

  .left-side {
    display: flex;
    flex-direction: column;
    width: calc(100% - 60px);
    align-items: flex-start;

    .white-link {
      margin-top: 20px;
      color: ${COLOR_WHITE};
    }

    p {
      text-overflow: ellipsis;
      max-width: calc(100% - 20px);
      overflow: hidden;
      a {
        color: ${COLOR_WHITE};
        padding: 0px;
        background: none;
        text-decoration: underline;
        font-size: 16px;
        text-align: left;
      }
      &:nth-child(2) {
        white-space: pre-wrap;
        text-overflow: initial;
        max-width: calc(100% - 20px);
      }
    }

    &.centered {
      min-height: 50px;
      p:first-child {
        margin: auto 0;
      }
    }

    &.loading {
      width: calc(100% - 150px);
    }
  }
  .right-side {
    width: 60px;
    width: fit-content;
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
    svg {
      margin-left: 32px;
    }
  }

  &.completed {
    .right-side {
      svg {
        #outline-transparent {
          fill: #ffffff;
        }
        #check-circle-2 {
          stroke: #ffffff;
        }
      }
    }
  }

  &.confirmation-pending {
    .right-side {
      svg {
        #outline-transparent {
          fill: ${COLOR_DARK_ORANGE};
        }
        #check-circle-2 {
          stroke: ${COLOR_DARK_ORANGE};
        }
      }
    }
    .left-side {
      p {
        a {
          color: ${COLOR_DARK_ORANGE};
        }
      }
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    ${({ loading }) => {
      if (loading) {
        return css`
          flex-direction: column-reverse;

          .left-side.loading {
            width: 100%;
          }

          .right-side {
            width: 100%;
          }
        `;
      }
    }}
  }
`;
